import React, { Children, useRef, useEffect, useState } from "react";
import { StyledBody } from "./styles";

const Body = ({ children, animated, bgColor }) => {
  const mref = useRef();
  const [bannerHeight, setBannerHeight] = useState(0);
  useEffect(() => {
    mref.current?.childNodes.forEach((node) =>
      setBannerHeight((prev) => prev + node?.clientHeight)
    );
  }, []);
  const renderBanner = (children) => {
    return Children.map(children, (child) => {
      if (child && !child.props) {
        return null;
      }
      if (
        child &&
        child.props.type !== undefined &&
        child.props.type === "banner"
      ) {
        return child;
      }
    });
  };

  const renderOtherComponents = (children) => {
    return Children.map(children, (child) => {
      if (child && !child.props) {
        return null;
      }
      // equal to (if (child == null || typeof child == 'string'))
      if (
        child &&
        child.props.type === undefined &&
        child.props.type !== "banner"
      ) {
        return child;
      }
    });
  };

  return (
    <div>
      <div ref={(el) => (mref.current = el)}>{renderBanner(children)}</div>
      <StyledBody bannerHeight={0} bgColor={{ bgColor }}>
        {renderOtherComponents(children)}
      </StyledBody>
    </div>
  );
};

export default Body;
